// Injects the SVG icon sprite into the page so <use xlink:href="#icon-..."/>
// references (e.g. dpl/common/components/Icon) can resolve.
import iconSprite from '../src/assets/icons_sprite.svg?raw';

const NODE_ID = 'gooddog-icons';

if (!document.body.querySelector(`#${NODE_ID}`)) {
  const node = document.createElement('div');
  node.id = NODE_ID;
  node.classList.add('dn');
  node.innerHTML = iconSprite;
  document.body.appendChild(node);
}
